import React, { useEffect } from 'react';
import {
  Button,
  Card,
  Column,
  Columns,
  Heading,
  Hidden,
  Stack,
  Text,
} from '@origin-digital/ods-core';

import { alert } from '@origin-digital/reporting-client';

export interface IHardStop {
  hasGasSelected?: boolean;
  triggerFindByNmi: () => void;
}

export const HardStopAlert = ({ hasGasSelected, triggerFindByNmi }: IHardStop) => {
  useEffect(() => {
    alert.base('error', {
      alertMessage: "Sorry, we can't show you exact pricing for electricity online right now.",
      alertCode: 'NMI_NOT_FOUND',
    });
  }, []);

  return (
    <Card
      backgroundColor="grey50"
      paddingYSpecific={['large', 'medium']}
      data-id="nmi-hard-stop-alert"
    >
      <Columns alignY="center" collapseBelow="md">
        <Column width="flex">
          <Stack space="small">
            <Stack space="xsmall">
              <Heading variant="h4">
                Hmm, we can’t find the electricity meter at that address
              </Heading>
              <Text>
                Enter your National Meter Identifier (NMI) for electricity pricing
                {hasGasSelected ? ', or continue with gas only' : '.'}
              </Text>
            </Stack>
            <Button size="small" variant="text" onClick={triggerFindByNmi} noTextPadding>
              Find your NMI
            </Button>
          </Stack>
        </Column>
        <Hidden below="md">
          <Column width="content">
            <img
              style={{ width: 'auto', maxHeight: '128px' }}
              src="https://www.originenergy.com.au/cdn/images/originenergy/image/upload/illustrations/illustration_find-nmi.svg"
              alt="Fing your NMI"
            />
          </Column>
        </Hidden>
      </Columns>
    </Card>
  );
};
